import type { AddressQuerySchema } from '@/_containers/inputs/address/shared/address-query-schema';

export function pickBillingAddresses(addresses: AddressQuerySchema[] | null | undefined): AddressQuerySchema[] {
  const list = addresses ?? [];
  if (!list.length) {
    return [];
  }

  const mailing = list.filter((address) => address.type === 'mailing');
  if (mailing.length > 0) {
    return mailing;
  }

  const physical = list.filter((address) => address.type === 'physical');
  if (physical.length > 0) {
    return physical;
  }

  return list;
}

export function formatAddressBlock(address: AddressQuerySchema): string {
  const lines: string[] = [];
  if (address.address1) {
    lines.push(address.address1);
  }
  if (address.address2) {
    lines.push(address.address2);
  }
  const state = address.state?.abbreviation ?? address.state?.name ?? '';
  const cityLine = [address.city, state, address.postal_code].filter(Boolean).join(', ');
  if (cityLine) {
    lines.push(cityLine);
  }
  if (address.country?.name) {
    lines.push(address.country.name);
  }

  return lines.join('\n');
}
